import { entities as DataKeySetEntities, resolvers as DataKeySetResolvers } from './data-key-set/index.js'
import { entities as DataOocEntities, resolvers as DataOocResolvers } from './data-ooc/index.js'
import { entities as DataSampleEntities, resolvers as DataSampleResolvers } from './data-sample/index.js'
import { entities as DataSensorEntities, resolvers as DataSensorResolvers } from './data-sensor/index.js'
import { entities as DataSetEntities, resolvers as DataSetResolvers } from './data-set/index.js'
import {
  entities as DataSetHistoryEntities,
  resolvers as DataSetHistoryResolvers,
  subscribers as DataSetHistorySubscribers
} from './data-set-history/index.js'
import { entities as DataSummaryEntities, resolvers as DataSummaryResolvers } from './data-summary/index.js'
import { entities as DataSpecEntities, resolvers as DataSpecResolvers } from './data-spec/index.js'
import { entities as DataArchiveEntities, resolvers as DataArchiveResolvers } from './data-archive/index.js'

/* EXPORT ENTITY TYPES */
export * from './data-summary/data-summary.js'
export * from './data-key-set/data-key-set.js'
export * from './data-ooc/data-ooc.js'
export * from './data-sensor/data-sensor.js'
export * from './data-sample/data-sample.js'
export * from './data-set/data-set.js'
export * from './data-set-history/data-set-history.js'
export * from './data-set/data-item-type.js'
export * from './data-spec/data-spec.js'

export const entities = [
  /* ENTITIES */
  ...DataSummaryEntities,
  ...DataKeySetEntities,
  ...DataOocEntities,
  ...DataSensorEntities,
  ...DataSampleEntities,
  ...DataSetEntities,
  ...DataSetHistoryEntities,
  ...DataSpecEntities,
  ...DataArchiveEntities
]

export const subscribers = [
  /* SUBSCRIBERS */
  ...DataSetHistorySubscribers
]

export const schema = {
  resolverClasses: [
    /* RESOLVER CLASSES */
    ...DataSummaryResolvers,
    ...DataKeySetResolvers,
    ...DataOocResolvers,
    ...DataSensorResolvers,
    ...DataSampleResolvers,
    ...DataSetResolvers,
    ...DataSetHistoryResolvers,
    ...DataSpecResolvers,
    ...DataArchiveResolvers
  ]
}
